// Custom components
import {
  UseFormRegister,
  FieldValues,
  FieldErrors,
  Path,
  RegisterOptions,
} from "react-hook-form";

interface ITextFieldProps<T>
  extends React.ComponentPropsWithoutRef<"textarea"> {
  id: Path<T>;
  label: string;
  extra: string;
  placeholder: string;
  variant: string;
  state?: string;
  disabled?: boolean;
  rows?: number;
  cols?: number;
  register: UseFormRegister<T>;
  errors: FieldErrors<T>;
  defaultValue?: string;
  validationSchema: RegisterOptions<T>;
}

const TextField = <T,>(props: ITextFieldProps<T>) => {
  const {
    label,
    id,
    extra,
    placeholder,
    variant,
    state,
    disabled,
    rows,
    cols,
    register,
    errors,
    validationSchema,
    defaultValue,
  } = props;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`text-sm text-navy-700 dark:text-white ${
          variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
        }`}
      >
        {" "}
        {label}
        {validationSchema.required && (
          <span className="text-red-500 dark:text-red-400">*</span>
        )}
      </label>
      <textarea
        disabled={disabled}
        id={id}
        cols={cols || 30}
        rows={rows || 10}
        placeholder={placeholder}
        defaultValue={defaultValue}
        className={`mt-2 flex w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none transition-all duration-300 ${
          disabled === true
            ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
            : state === "error" || errors[id]
            ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
            : state === "success"
            ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
            : "border-gray-200 dark:!border-white/10 dark:text-white"
        }`}
        {...register(id, validationSchema)}
      />
      {errors.root && (
        <span className="ml-2 mt-1 text-sm text-red-500 dark:text-red-400">
          {errors.root.message.toString()}
        </span>
      )}
    </div>
  );
};

export default TextField;
